import React, { useState } from "react";
import "./index.scss";

interface Props {
  placeholder?: string;
  iframe: string;
}

const VideoFrame = ({ placeholder, iframe }: Props) => {
  const [isVideoVisible, setVideoVisible] = useState(
    placeholder && placeholder.length ? false : true
  );
  return (
    <div className="video-frame-wrapper">
      <div className="video-frame">
        <div
          className="video-frame__placeholder"
          style={{ backgroundImage: `url("${placeholder}")` }}
          onClick={() => setVideoVisible(true)}
        ></div>
        {isVideoVisible && (
          <iframe
            src={iframe}
            allowFullScreen
            frameBorder="0"
            allow="autoplay; fullscreen"
          ></iframe>
        )}
      </div>
    </div>
  );
};

export default VideoFrame;
